// Generated by Melange

import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__PlayerContext from "./playerContext.jsx";

function make(volume) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    store.setState(function (prevState) {
      const init = prevState.player;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: prevState.auth,
        player: {
          buffered: init.buffered,
          currentSongId: init.currentSongId,
          currentTime: init.currentTime,
          duration: init.duration,
          muted: init.muted,
          paused: init.paused,
          queuedSongIds: init.queuedSongIds,
          replayGainOptions: init.replayGainOptions,
          volume: Math.max(0.0, Math.min(Curry._1(volume, prevState.player.volume), 1.0))
        },
        songs: prevState.songs
      };
    });
    Stdlib__Option.iter((function (param) {
      const state = store.getState();
      param.volumeNode.gain.value = state.player.volume;
    }), StoreFx__PlayerContext.value.contents);
    return {
      TAG: /* Ok */ 0,
      _0: undefined
    };
  }));
}

export {
  make,
}
/* StoreFx__PlayerContext Not a pure module */
